import browse from './browse.vue';
import form from './form.vue';
import permissions from './permissions';
import read from './read.vue';
import users from './users';

export default { browse, create: form, read, edit: form, permissions, users };
